import React, { Component } from 'react';
import { Button, Drawer } from '@nackle/paper';
import './slide-in-panel.less';


/**
 * When the CMX TranslationEditor component spawns its own pane, we want this component to still appear underneath.
 * The default size (used by TranslationEditor) is 50%. So we make ours slightly bigger than that.
 */
// const DRAWER_SIZE = '60%';

interface SlideInPanelProps {
    readonly buttonProps: (typeof Button extends Component<infer P> ? P : any);
    readonly buttonText?: string;
    readonly children?: any;
    readonly slide?: boolean;
    readonly buttonId?: string;
    readonly onClose?: any;
    readonly onOpen?: any;
    readonly disabled?: boolean;
    readonly title: string;
    readonly childPanelOpen?: boolean;
    readonly className?: string;
    // For unit tests
    readonly usePortal?: boolean;
}

interface State {
    isOpen: boolean;
}

export default class SlideInPanel extends Component<SlideInPanelProps, State> {
    state = {
        isOpen: !!this.props.slide
    };

    componentDidUpdate(prevProps) {
        const slide = Boolean(this.props.slide);
        if (prevProps.slide !== slide) {
            this.setOpen(slide);
        }
    }

    private handleOpen = () => this.setOpen(true);
    private handleClose = () => this.setOpen(false);

    private setOpen = (isOpen: boolean) => {
        this.setState({ isOpen });
        const { onOpen, onClose } = this.props;
        if (!!onOpen && isOpen) {
            onOpen();
        }
        if (!!onClose && !isOpen) {
            onClose();
        }
    };

    render () {
        const {
            buttonProps,
            childPanelOpen = true,
            disabled,
            title,
            className,
        } = this.props;
        return (
            <>
                <Button
                    {...buttonProps}
                    disabled={disabled}
                    onClick={this.handleOpen}
                    type="primary"
                    >   
                    {title}
                    </Button>
                <Drawer
                    z-index={1001}
                    closable={!childPanelOpen}
                    visible={this.state.isOpen}
                    onClose={this.handleClose}
                    width={736}
                    title={title}
                    className={className}
                >
                    <div className="drawer-body">
                        <div className="dialog-body">
                            {this.props.children}
                        </div>
                    </div>
                    <div className="drawer-footer">
                        <div className="dialog-footer-actions">
                            <Button
                                className="close-slide-in-panel-btn"
                                onClick={this.handleClose}
                                style={{marginTop: 10}}
                            >
                                Close
                            </Button>
                        </div>
                    </div>
                </Drawer>
            </>
        );
    }
}

